import React from 'react';

const Footer = () => (
  <footer className="container mx-auto py-16 px-16 mt-48 mb-8 text-gray-800">
    <div className="flex">
      <div className="">
        <h2 className="text-lg font-semibold">About Us</h2>
        <p className="mt-5">
          From beautiful sunny Barcelona. <br />
          We make your digital project come alive.
        </p>
        <p className="mt-5">&copy; 2011 - {new Date().getFullYear()} JP engineering</p>
      </div>
    </div>
  </footer>
);

export default Footer;
